import { useMutation } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import CustomAxios from '../../../utility/customAxios';

export const destroyPreference = async (uuid: string) => {
  const response = await CustomAxios.delete(`preferences/${uuid}`);
  const { data } = response;
  return data;
};
interface UseDestroyPreferenceFormProps {
  uuid: string;
  onSuccessCallback: () => void;
}
export function useDestroyPreference({ uuid, onSuccessCallback }: UseDestroyPreferenceFormProps) {
  return useMutation({
    mutationFn: () => destroyPreference(uuid),
    onSuccess: () => {
      onSuccessCallback();
    },
    onError: (err: AxiosError) => {
      if (err?.response?.status === 400) {
        alert('Failed to delete the event. Please try again and contact support if the problem persists.');
      }
    },
  });
}
